import { TransferOrderReceivingDetailPage } from "@/features/po-receiving/pages/transfer-order/TransferOrderReceivingDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/admin/receiving/transfer-order/$id/detail",
)({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["to_receiving.view_detail"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: TransferOrderReceivingDetailPage,
});
